const BREAKPOINTS = {
  xxs: 320,
  xs: 480,
  m: 768, // tablet
  ml: 960, // large tablet
  l: 1024, // desktop
  xl: 1200, // large desktop
}

export default BREAKPOINTS